module.exports = __webpack_public_path__ + "static/img/quan3.a69b535.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/Header/images/quan3.png
// module id = HufE
// module chunks = 1 2 3 4